import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const TrailerFilters = ({ setCardsFilters, cardsFilters, onResetFilters }) => {
  const handleChange = event => {
    setCardsFilters({ location: event.target.value });
  };

  return (
    <>
      <TextField
        fullWidth
        label="Location"
        name="Location"
        onChange={handleChange}
        value={cardsFilters.location}
      />

      <Button fullWidth onClick={onResetFilters} sx={{ mt: 2 }} variant="text">
        Clear
      </Button>
    </>
  );
};

TrailerFilters.propTypes = {
  cardsFilters: PropTypes.shape({
    location: PropTypes.string,
  }).isRequired,
  onResetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default TrailerFilters;
